import React from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { LayoutGap, TileSkeleton } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const RezaTemplateListSkeleton = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const t = getLocalizeCurried(LocalizeNameSpaceTypes.Global);

	return (
		<LayoutGap>
			{[0, 1, 2, 3, 4].map((i) => (
				<TileSkeleton key={i}>
					<GovSkeleton
						width="75%"
						height="22px"
						color="neutral"
						aria-label={t('loading.wcag.processing')}
						className="mb-4 pb-0"
					/>
					<GovSkeleton
						width={generateRandomNumber(80, 100) + '%'}
						height="22px"
						color="neutral"
						aria-label={t('loading.wcag.processing')}
						className="mb-0 pb-0"
					/>
					<GovSkeleton
						width={generateRandomNumber(40, 100) + '%'}
						height="22px"
						color="neutral"
						aria-label={t('loading.wcag.processing')}
						className="mb-0 pb-0"
					/>
				</TileSkeleton>
			))}
		</LayoutGap>
	);
};
